/**
 * Responsieve niveaus worden gemeten op de breedte van de *container*, niet op
 * die van het venster. Een inspecteur werkt op een tablet in landscape
 * (1180-1280 px), maar dezelfde component kan in een smalle kolom staan.
 */
export const BREAKPOINTS = {
    /** Volledige weergave: alle kolommen naast elkaar. */
    wide: 1250,
    /** Compacter: secundaire kolom klapt in. */
    mid: 1000,
    /**
     * Telefoon. Geen eigen niveau maar een vlag: alles onder `mid` valt al terug op
     * één kolom, maar onder deze breedte past ook een tabel met een `min-width` niet
     * meer zonder horizontaal te schuiven. Daar wordt een lijst een stapel kaarten.
     */
    phone: 640,
} as const;

export type BreakpointLevel = 'narrow' | 'mid' | 'wide';

export interface BreakpointState {
    level: BreakpointLevel;
    width: number;
    isWide: boolean;
    isMid: boolean;
    isNarrow: boolean;
    /** Onder 640 px: één kolom, grote raakvlakken, geen tabel die schuift. */
    isPhone: boolean;
}

export function resolveBreakpoint(width: number): BreakpointLevel {
    if (width >= BREAKPOINTS.wide) {
        return 'wide';
    }

    if (width >= BREAKPOINTS.mid) {
        return 'mid';
    }

    return 'narrow';
}

export function toBreakpointState(width: number): BreakpointState {
    const level = resolveBreakpoint(width);

    return {
        level,
        width,
        isWide: level === 'wide',
        isMid: level === 'mid',
        isNarrow: level === 'narrow',
        /* Een breedte van 0 is "nog niet gemeten"; dan liever de brede weergave dan een
           telefoonlayout die na de eerste meting weer wegspringt. */
        isPhone: width > 0 && width < BREAKPOINTS.phone,
    };
}
